import React, { useState } from "react";
import SubPageLayout from "../components/SubPageLayout";
import { NAAVI_FAQS, NAAVI_ADDRESS } from "../data/site";
import { Plus, Minus } from "lucide-react";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <SubPageLayout
      eyebrow="FAQs"
      title={<>Have questions? <span className="italic font-normal">We have warm answers</span>.</>}
      subtitle="From admissions and ratios to our signature curriculum — here are the things parents most often ask before joining the Naavi family."
      accent="lime"
      decor="flower"
    >
      <section className="py-14 md:py-24 bg-[#FAFAF5]">
        <div className="max-w-3xl mx-auto px-5 md:px-8">
          <ul className="space-y-3" data-testid="faq-list">
            {NAAVI_FAQS.map((f, i) => {
              const isOpen = open === i;
              return (
                <li key={i} className="bg-[#E3EDF9] rounded-3xl border border-[#0F1B47]/6 overflow-hidden">
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
                    aria-expanded={isOpen}
                    aria-controls={`faq-answer-${i}`}
                    data-testid={`faq-toggle-${i}`}
                  >
                    <span className="text-[#0F1B47] font-semibold text-[15px] md:text-base">{f.q}</span>
                    <span className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${isOpen ? "bg-[#0F1B47] text-[#FDFDF9]" : "bg-[#FDFDF9] text-[#0F1B47]"}`}>
                      {isOpen ? <Minus size={14} /> : <Plus size={14} />}
                    </span>
                  </button>
                  {isOpen && (
                    <div id={`faq-answer-${i}`} role="region" className="px-6 pb-6 text-[#4A5568] text-[15px] leading-relaxed font-light" data-testid={`faq-answer-${i}`}>
                      {f.a}
                    </div>
                  )}
                </li>
              );
            })}
          </ul>

          <div className="mt-12 bg-[#0F1B47] rounded-3xl p-8 md:p-10 text-center text-[#FDFDF9]">
            <span className="text-xs font-bold tracking-[0.22em] uppercase text-[#C6D947]">Still curious?</span>
            <h3 className="font-display text-2xl md:text-3xl font-medium mt-2 mb-4">Speak to our admissions team.</h3>
            <a href={`tel:${NAAVI_ADDRESS.phone.replace(/\s/g, "")}`} className="inline-flex items-center gap-2 bg-[#C6D947] text-[#0F1B47] rounded-full px-7 py-3.5 font-semibold text-sm hover:-translate-y-0.5 transition-transform">
              Call {NAAVI_ADDRESS.phone}
            </a>
          </div>
        </div>
      </section>
    </SubPageLayout>
  );
}
